interface FormSectionProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

export function FormSection({ title, description, children }: FormSectionProps) {
  return (
    <div className="flex flex-col gap-3 p-3">
      <div className="flex flex-col gap-1">
        <p className="text-base font-semibold text-(--color-text-primary)">{title}</p>
        {description && <p className="text-sm text-(--color-text-secondary)">{description}</p>}
      </div>
      {children}
    </div>
  );
}
